import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { obtenerJuegos } from '../api';
import pricing_img from '../assets/pricing-carousel.png';

const brand = {
  nearBlack: '#141318',
  blueGray: '#566D87',
  gold: '#FFD404',
  light: '#E9EAE8',
  white: '#FFFFFF',
  ink: '#00181C',
};

const Pricing = () => {
  const [juegos, setJuegos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const usd = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(n || 0));

  useEffect(() => {
    const fetchJuegos = async () => {
      try {
        const data = await obtenerJuegos();
        setJuegos(data);
        setLoading(false);
      } catch (error) {
        setError('No se pudieron cargar los juegos');
        setLoading(false);
      }
    };

    fetchJuegos();
  }, []);

  if (loading)
    return (
      <div
        style={{
          color: '#E9EAE8',
          backgroundColor: '#141318',
          textAlign: 'center',
          padding: '20px',
          fontFamily: "'Inter', sans-serif",
          fontSize: '1rem',
        }}
      >
        Cargando juegos...
      </div>
    );
  if (error)
    return (
      <div
        style={{
          color: '#E9EAE8',
          backgroundColor: '#141318',
          textAlign: 'center',
          padding: '20px',
          fontFamily: "'Inter', sans-serif",
          fontSize: '1rem',
        }}
      >
        {error}
      </div>
    );

  return (
    <div style={{ backgroundColor: brand.nearBlack }}>
      <div
        className="container text-center"
        style={{
          padding: '5vw 0',
        }}
      >
        <h2
          style={{
            fontFamily: "'Audiowide', sans-serif",
            color: brand.blueGray,
            fontSize: 'clamp(1.8rem, 6vw, 2.5rem)',
            marginBottom: '1rem',
          }}
        >
          Game Modes
        </h2>
        <p
          style={{
            fontFamily: "'Inter', sans-serif",
            color: brand.light,
            fontSize: 'clamp(0.9rem, 3vw, 1.1rem)',
            maxWidth: '90%',
            margin: '0 auto',
          }}
        >
          Step into the action and choose your mission! From team battles to solo challenges, each mode drops you into a high-energy laser tag arena where strategy, reflexes, and adrenaline decide who comes out on top.
        </p>
      </div>
      <div
        className="container-fluid"
        style={{
          backgroundImage: `url(${pricing_img})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          position: 'relative',
          height: '65vh',
        }}
      >
        <Carousel indicators={false} controls={true} interval={null}>
          {juegos.map((juego) => (
            <Carousel.Item key={juego.id}>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  height: '65vh',
                  backgroundColor: 'rgba(20, 19, 24, 0.72)',
                  color: brand.light,
                  textAlign: 'center',
                  padding: 'clamp(10px, 5vw, 24px)',
                }}
              >
                <div
                  style={{
                    background: 'rgba(20, 19, 24, 0.78)',
                    backdropFilter: 'blur(6px)',
                    border: `1px solid ${brand.blueGray}33`,
                    borderRadius: 18,
                    padding: '24px 28px',
                    maxWidth: 760,
                    width: 'clamp(280px, 86vw, 760px)',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.35), 0 0 0 1px rgba(255, 212, 4, 0.22) inset, 0 0 22px rgba(255, 212, 4, 0.10), 0 0 42px rgba(255, 212, 4, 0.08)',
                    position: 'relative',
                    overflow: 'hidden',
                    textAlign: 'center',
                    zIndex: 0,
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.35), 0 0 0 1px rgba(255, 212, 4, 0.30) inset, 0 0 28px rgba(255, 212, 4, 0.14), 0 0 58px rgba(255, 212, 4, 0.12)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.35), 0 0 0 1px rgba(255, 212, 4, 0.22) inset, 0 0 22px rgba(255, 212, 4, 0.10), 0 0 42px rgba(255, 212, 4, 0.08)';
                  }}
                >
                  <span style={{ position: 'absolute', inset: -2, background: `radial-gradient(800px 300px at 110% -10%, ${brand.blueGray}19, transparent 70%)`, zIndex: 0 }} />
                  <span className="moving-sheen" style={{ zIndex: 0 }} />
                  <span className="glass-border-gradient" style={{ zIndex: 0 }} />
                  <span className="glass-top-gloss" style={{ zIndex: 0 }} />
                  <span className="glass-noise" style={{ zIndex: 0 }} />
                  <span className="glass-inner-shadow" style={{ zIndex: 0 }} />
                  <span className="glass-specular-arc" style={{ zIndex: 0 }} />
                  <span className="glass-bottom-glow" style={{ zIndex: 0 }} />
                  <span style={{ position: 'absolute', inset: 0, borderRadius: 18, pointerEvents: 'none', border: '1px solid rgba(255, 212, 4, 0.18)', boxShadow: 'inset 0 0 10px rgba(255, 212, 4, 0.12)' }} />
                  <div style={{ position: 'relative', zIndex: 1 }}>
                    {juego.categoria_nombre && (
                      <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <span style={{ backgroundColor: `${brand.blueGray}33`, color: brand.white, border: `1px solid ${brand.blueGray}66`, padding: '6px 10px', borderRadius: 999, fontFamily: "'Inter', sans-serif", fontSize: '0.85rem' }}>
                          {juego.categoria_nombre}
                        </span>
                        <span style={{ backgroundColor: 'transparent', color: brand.light, border: `1px solid ${brand.gold}66`, padding: '6px 10px', borderRadius: 999, fontFamily: "'Inter', sans-serif", fontSize: '0.85rem' }}>
                          {juego.duracion} min
                        </span>
                      </div>
                    )}
                    <h3
                      style={{
                        fontFamily: "'Audiowide', sans-serif",
                        color: brand.white,
                        fontSize: 'clamp(1.4rem, 5vw, 2rem)',
                        margin: '12px 0 4px',
                        lineHeight: 1.15,
                        textShadow: '0 2px 10px rgba(0,0,0,0.3)'
                      }}
                    >
                      {juego.nombre}
                    </h3>
                    <div style={{ width: 64, height: 3, backgroundColor: brand.gold, borderRadius: 2, margin: '8px auto 12px' }} />
                    <p
                      style={{
                        fontFamily: "'Inter', sans-serif",
                        color: brand.light,
                        fontSize: 'clamp(0.95rem, 2.5vw, 1.05rem)',
                        lineHeight: 1.6,
                        margin: '0 0 14px',
                        opacity: 0.95,
                      }}
                    >
                      {juego.descripcion}
                    </p>
                    <div style={{ display: 'flex', gap: 16, alignItems: 'baseline', justifyContent: 'center', flexWrap: 'wrap' }}>
                      <div style={{ fontFamily: "'Inter', sans-serif", color: brand.light, fontSize: 'clamp(0.9rem, 2.2vw, 1rem)' }}>
                        <span style={{ opacity: 0.85 }}>From:</span> <span style={{ fontWeight: 700, color: brand.white }}>{usd(juego.precio_base)}</span>
                      </div>
                      {Number(juego.precio_extra_por_jugador || 0) > 0 && (
                        <div style={{ fontFamily: "'Inter', sans-serif", color: brand.light, fontSize: 'clamp(0.8rem, 2vw, 0.95rem)', opacity: 0.95 }}>
                          Extra: {usd(juego.precio_extra_por_jugador)} per player over {juego.capacidad_base}
                        </div>
                      )}
                    </div>
                    <div style={{ marginTop: 16 }}>
                      <a
                        href="/pricing"
                        className="btn"
                        style={{
                          fontFamily: "'Inter', sans-serif",
                          backgroundColor: brand.gold,
                          color: brand.ink,
                          border: 'none',
                          padding: 'clamp(10px, 2vw, 12px) clamp(18px, 4vw, 22px)',
                          fontSize: 'clamp(0.95rem, 2.5vw, 1.05rem)',
                          fontWeight: 700,
                          borderRadius: 999,
                          boxShadow: '0 6px 18px rgba(255, 212, 4, 0.25)',
                          transition: 'transform 180ms ease, box-shadow 180ms ease',
                          textDecoration: 'none',
                          display: 'inline-block'
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                        onFocus={(e) => (e.currentTarget.style.boxShadow = '0 8px 22px rgba(255, 212, 4, 0.35)')}
                        onBlur={(e) => (e.currentTarget.style.boxShadow = '0 6px 18px rgba(255, 212, 4, 0.25)')}
                      >
                        Book Now
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Pricing;